import React, { useState, useEffect, useMemo } from "react";
import { DefaultWidgetContextMenu } from "../../components/DefaultWidgetContextMenu";
import { FloatingLabelContainer } from "../../components/FloatingLabel";

// Externals
import cn from "classnames";

// DevExtreme components
import { TextBox, TextArea } from 'devextreme-react';
import { Button as TextBoxButton } from 'devextreme-react/text-box';

// Component styles
import classes from "./StringWidget.module.scss";

const EMPTY = undefined;

export function StringWidget(props) {
  const { ui, config, data, writeBack, startWork, isBaseWidgetFor, useMonospaceFont, actionButtonOptions, useFloatingLabel } = props;
  const widgetId = ui.id;

  const [localContent, setLocalContent] = useState(EMPTY);
  const [hasFocus, setHasFocus] = useState(false);

  let content = localContent !== EMPTY ? localContent : data && data.content ? data.content : null;
  let disabled = ui.readonly || (data && data.readonly);

  let multiline = config ? config.Multiline : false;
  //let rows = config ? config.Rows : 1;

  let showActionButton = actionButtonOptions && actionButtonOptions.action;

  useEffect(() => {
    let widgetType = isBaseWidgetFor ? isBaseWidgetFor : "StringWidget";
    console.log(widgetType + " data of " + ui.id + ": ", data);
    setLocalContent(EMPTY);
  }, [data]);

  const actionButtonOptionsMemo = useMemo(() => {
    if (!actionButtonOptions) return;
    return {
      icon: actionButtonOptions.icon || 'edit',
      stylingMode: 'text',
      onClick: (args) => {
        var textElement = args.element.parentElement.parentElement.firstChild.firstChild;
        actionButtonOptions.action(content, textElement);
      }
    };
  }, [actionButtonOptions, content]);

  const setContent = (value, force) => {
    setLocalContent(value);
    writeBack(value, force);
  };

  const handleOnCopy = () => {
    return content;
  };

  const handleOnPaste = (value) => {
    setLocalContent(value);
    writeBack(value, true);
  };

  const handleOnDelete = () => {
    setLocalContent(null);
    writeBack(null, true);
  };

  return (
    <DefaultWidgetContextMenu
      widgetId={widgetId}
      onCopy={handleOnCopy}
      onPaste={handleOnPaste}
      onDelete={handleOnDelete}
      editable={!disabled}
    >
      <FloatingLabelContainer condition={useFloatingLabel} widgetId={widgetId} hasContent={content} hasFocus={hasFocus} text={ui.label}>
        {multiline
          ? (
            <TextArea 
              className={cn(classes.textArea, 
                useFloatingLabel ? classes.withFloatingLabel : "",
                disabled ? classes.disabled : "",
                useMonospaceFont ? classes.monospace : "")}
              id={widgetId}
              value={content}
              onFocusOut={() => setHasFocus(false)}
              onFocusIn={() => setHasFocus(true)}
              onKeyUp={() => startWork()}
              onValueChanged={e => setContent(e.value)}
              disabled={disabled}
              height={"100%"}
            >
              {showActionButton
                ? (
                  <TextBoxButton
                    name={"actionButton" + widgetId}
                    location="after"
                    options={actionButtonOptionsMemo}
                  />
                )
                : null
              }
            </TextArea>
          )
          : (
            <TextBox
              className={cn(
                useFloatingLabel ? classes.withFloatingLabel : "",
                disabled ? classes.disabled : "",
                useMonospaceFont ? classes.monospace : "")}
              id={widgetId}
              value={content}
              onFocusOut={() => setHasFocus(false)}
              onFocusIn={() => setHasFocus(true)}
              onKeyUp={() => startWork()}
              onValueChanged={e => setContent(e.value)}
              disabled={disabled}
              height={ui.controlHeight + "em"}
            >
              {showActionButton
                ? (
                  <TextBoxButton
                    name={"actionButton" + widgetId}
                    location="after"
                    options={actionButtonOptionsMemo}
                  />
                )
                : null
              }
            </TextBox>
          )
        }
      </FloatingLabelContainer>
    </DefaultWidgetContextMenu>
  );
}